import { Actor } from "../actors/Actor";
import { Stat } from "../actors/Stat";

export enum StatType {
  none = "none",
  health = "health",
  wand = "wand",
  hunger = "hunger",
}

export enum StatAdjustmentType {
  SET = "set",
  GAIN = "gain",
  LOSE = "lose",
  MAX = "max",
}

export class StatAdjust {
  stat: StatType;
  type: StatAdjustmentType;
  amount: number;

  constructor(data: any) {
    this.stat = data.stat;
    this.type = data.type;
    this.amount = data.amount;
  }

  apply(target: Actor) {
    switch (this.stat) {
      case StatType.health:
        this.adjustStatObject(target.health);
        break;
      case StatType.hunger:
        this.adjustStatObject(target.hunger);
        break;
      case StatType.wand:
        target.maxLetters += this.amount; //Only support adjusting max for spellwand
    }
  }

  adjustStatObject(statObject: Stat) {
    switch (this.type) {
      case StatAdjustmentType.GAIN:
        statObject.change(this.amount);
        break;
      case StatAdjustmentType.LOSE:
        statObject.change(this.amount * -1);
        break;
      case StatAdjustmentType.SET:
        statObject.current = this.amount;
        break;
      case StatAdjustmentType.MAX:
        statObject.adjustMax(this.amount, this.amount > 0);
    }
  }
}
